var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMarketplaceLooksrare = function SvgIcnMarketplaceLooksrare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "#080404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4 11.095 4.803-4.778h6.394L20 11.095l-8 7.96-8-7.96ZM8.58 9.42a4.833 4.833 0 0 1 6.84 0l1.633 1.634-1.632 1.634a4.833 4.833 0 0 1-6.842 0l-1.632-1.634L8.58 9.42Z",
    fill: "#0CE465"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.107c0 1.076.895 1.948 2 1.948s2-.872 2-1.947c0-1.076-.895-1.948-2-1.948s-2 .872-2 1.947Zm1.158-.052a.842.842 0 1 0 1.684 0 .842.842 0 0 0-1.684 0Z",
    fill: "#fff"
  })));
};
export default SvgIcnMarketplaceLooksrare;